export default {
  getValidMode: (state) => state.validMode.state,
  modalFullScreen: (state) => state.modalFullScreen,
  modalRightScreen: (state) => state.modalRightScreen,
  getLoadingState: (state) => state.loading,
};
